var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"defaultContentView"},[_c('h1',{staticClass:"display-1 mb-3 primary--text"},[_vm._v(" "+_vm._s(_vm.l("Error 403"))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.l("You are not permitted to access this page."))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }